import clsx from 'clsx'

import CartDrawer from '../../../checkout/components/CartDrawer'
import useCartDrawerOpen from '../../../checkout/hooks/useCartDrawerOpen'

import MainFooter from './footer/MainFooter'
import MainNavbar from './navBar/MainNavbar'
import MobileSideDrawer from './navBar/MobileSideDrawer'
import styles from './MainLayout.module.scss'

function MainLayout({ children }: React.PropsWithChildren) {
  const isCartDrawerVisible = useCartDrawerOpen()

  return (
    <>
      <MainNavbar />
      <div
        className={clsx(styles.content, {
          [styles.drawerOpen]: isCartDrawerVisible,
        })}
      >
        {children}
      </div>
      <MainFooter />
      <CartDrawer />
      <MobileSideDrawer />
    </>
  )
}

export default MainLayout
